import React from "react";
import {
    Grid,
    Box,
} from "@mui/material";

const PresentationNavBar = (props) => {
    return (
        <>
            <Grid container >
                <Grid item xs={12} className={"top-gradient-bar bar-with-text"} >
                    <Box style={{ marginLeft: '6%', fontSize: '28px', display: 'flex', flexDirection: 'row' }}>
                        {props.children[0]}
                    </Box>
                </Grid>
            </Grid>
            {props.children[1]}
        </>);
};

export default PresentationNavBar;
